<template>
  <span>
    <v-container fluid fill-height class='back' :style='backgroundStyle'>
      <v-layout row>
        <v-flex xs12>
          <v-container fluid >
            <v-layout row wrap fill-height justify-center>
              <v-flex xs12 mt-5 mb-5 text-xs-center>
                <h3 class='oem-text-color display-3'>Power Meter Data Manager</h3>
                <h5  class='oem-text-color display-1'>Login to access meter setup and data</h5>
              </v-flex>
              <v-flex xs12>
                  <v-layout row  wrap justify-center>
                    <v-flex xs8 md7 class='elevation-2 white'>
                      <v-layout row align-center class='pa-5'>
                        <v-flex xs10 md4 offset-xs1>
                          <v-form v-on:submit.prevent='handleLogin'>
                            <v-text-field
                              v-if='storeState.data.pinEnabled'
                              type="password"
                              mask='####'
                              v-model='pincode'
                              label='4-Digit Passcode'
                              @input='clearErrors()'
                              :error-messages='errorMsg'
                            ></v-text-field>
                            <v-btn
                              v-if='storeState.data.pinEnabled'
                              @click='handleLogin'
                              class='oem-color ml-0 pl-0' >
                                Login
                            </v-btn>
                            <v-btn
                              v-else
                              @click='passwordDialog = true'
                              class='oem-color ml-0 pl-0' >
                                Login
                            </v-btn>
                          </v-form>
                        </v-flex>
                        <v-flex md8 offset-xs1 class='verticalLine hidden-sm-and-down'>
                          <device-info></device-info>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs8 class='mt-3 elevation-2 white hidden-md-and-up' >
                      <deviceInfo></deviceInfo>
                    </v-flex>
                  </v-layout>
              </v-flex>
              <v-snackbar
                v-model="snackbar"
                :timeout="5000"
                :top='true'
              >
                {{ snackbarText }}
                <v-btn
                  class='oem-color-text'
                  flat
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </v-snackbar>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-dialog v-model='passwordDialog' persistent max-width='500px'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Set Passcode
          </v-card-title>
          <v-card-text>
            <div class='ma-3'>
              <v-text-field
                mask='####'
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :type="show1 ? 'text' : 'password'"
                v-model='password1'
                name="input-10-2"
                label="New passcode"
                @click:append="show1 = !show1"
                @input='validatePassword'
                :error-messages='errorMsg'
              ></v-text-field>
              <v-text-field
                mask='####'
                v-model='password2'
                :append-icon="show2 ? 'visibility' : 'visibility_off'"
                :type="show2 ? 'text' : 'password'"
                label="Confirm passcode"
                @click:append="show2 = !show2"
                @input='validatePassword'
                :error-messages='errorMsg'
                class='pt-4'
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class='oem-button' flat @click='close'>Cancel</v-btn>
            <v-btn
              class='oem-button'
              flat
              @click='save'
              :disabled='!valid'
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    </v-container>
  </span>
</template>
<script>

import * as auth from '../auth';
import ajax from '../ajax';
// import router from '../routes';
import deviceInfo from './BaseDeviceInfo.vue';

const background = require('../assets/img/background.png');

export default {
  name: 'Login',
  components: {
    deviceInfo,
  },
  data() {
    return {
      storeState: this.$store.state,
      pincode: '',
      errorMsg: [],
      snackbar: false,
      snackbarText: '',
      passwordDialog: false,
      valid: true,
      show1: false,
      show2: false,
      password1: '',
      password2: '',
      info: [
        { key: 'Product', value: 'Power meter' },
        { key: 'Model', value: 'SPM48EDN' },
        { key: 'Serial no.', value: '5678912' },
        { key: 'Date', value: false },
        { key: 'Time', value: false },
      ],
    };
  },
  computed: {
    staticInfo() {
      return this.info.filter(obj => (
        obj.value
      ));
    },
    backgroundStyle() {
      if (this.storeState.style === 'fluke') {
        document.documentElement.style.setProperty('--primary-color', '#ffc20e');
        document.documentElement.style.setProperty('--secondary-color', '#212121');
        document.documentElement.style.setProperty('--tertiary-color', '#ffc20e');
        document.documentElement.style.setProperty('--primary-text-color', '#000');
        document.documentElement.style.setProperty('--secondary-text-color', '#000');
        document.documentElement.style.setProperty('--tertiary-text-color', '#fff');
        document.documentElement.style.setProperty('--quaternary-text-color', '#000');
      }

      if (this.storeState.style === 'siemens') {
        document.documentElement.style.setProperty('--primary-color', '#099');
        document.documentElement.style.setProperty('--secondary-color', '#ebf0f5');
        document.documentElement.style.setProperty('--tertiary-color', '#dee5ec');
        document.documentElement.style.setProperty('--primary-text-color', '#fff');
        document.documentElement.style.setProperty('--secondary-text-color', '#697882');
        document.documentElement.style.setProperty('--tertiary-text-color', '#697882');
        document.documentElement.style.setProperty('--quaternary-text-color', '#697882');
      }

      if (this.storeState.style === 'setra') {
        document.documentElement.style.setProperty('--primary-color', '#1d428a');
        document.documentElement.style.setProperty('--secondary-color', '#f3f4f8');
        document.documentElement.style.setProperty('--tertiary-color', '#c7d0e1');
        document.documentElement.style.setProperty('--primary-text-color', '#fff');
        document.documentElement.style.setProperty('--secondary-text-color', '#1d428a');
        document.documentElement.style.setProperty('--tertiary-text-color', '#1d428a');
        document.documentElement.style.setProperty('--quaternary-text-color', '#8597bd');
      }
      // Setting Background image
      return { 'background-image': `url(${background})` };
    },
  },
  methods: {
    handleLogin() {
      let code = '0000';
      if (this.storeState.data.pinEnabled) {
        code = this.pincode;
      }
      ajax.post('login', { pincode: code })
        .then((response) => {
          if (response.response && response.response.status === 403) {
            this.errorMsg = [];
            this.errorMsg.push('Invalid passcode');
          } else {
            const { token: jwt } = response.data;
            auth.setAccessToken(jwt);
            this.$router.push({ name: 'home' });
          }
        })
        .catch((e) => {
          if (e.response) {
            if (e.response.status === 403) {
              this.errorMsg = [];
              this.errorMsg.push('Invalid passcode');
            } else {
              this.snackbarText = `Unexpected server error: ${e.response.statusText}`;
              this.snackbar = true;
            }
          } else {
            this.snackbarText = `Unexpected server error: ${e.message}`;
            this.snackbar = true;
          }
        });
    },
    validatePassword() {
      this.errorMsg = [];
      this.valid = true;
    },
    close() {
      this.passwordDialog = false;
      this.password1 = '';
      this.password2 = '';
    },
    clearErrors() {
      this.errorMsg = [];
    },
    save() {
      if (this.password1.length !== 4 || this.password2.length !== 4) {
        this.errorMsg.push('Passcodes needs to be exactly 4 digits');
        this.valid = false;
      } else if (this.password1 !== this.password2) {
        this.errorMsg.push('Passcodes do not match');
        this.valid = false;
      } else {
        this.pincode = this.password1;
        ajax.post('login', { pincode: this.pincode })
          .then((response) => {
            if (response.response && response.response.status === 403) {
              this.errorMsg = [];
              this.errorMsg.push('Invalid passcode');
            } else {
              const { token: jwt } = response.data;
              auth.setAccessToken(jwt);
              ajax.put('login', { pincode: this.pincode, enabled: true })
                .then(() => {
                  this.$store.addEventLog('Updated passcode');
                  auth.setAccessToken('');
                })
                .catch((e) => {
                  console.log(e); // eslint-disable-line no-console
                  this.$store.addEventLog(`Failed to update passcode. Error ${e}`);
                });
            }
          })
          .catch((e) => {
            if (e.response) {
              if (e.response.status === 403) {
                this.errorMsg = [];
                this.errorMsg.push('Invalid passcode');
              } else {
                this.snackbarText = `Unexpected server error: ${e.response.statusText}`;
                this.snackbar = true;
              }
            } else {
              this.snackbarText = `Unexpected server error: ${e.message}`;
              this.snackbar = true;
            }
          });
        this.storeState.data.pinEnabled = true;
        this.close();
      }
    },
  },
  beforeMount() {
    this.$store.updateTimezones();
    this.$store.getBaseTime();
    this.$store.updateLogin();
  },
};
</script>
<style>
.back  {
  background-size: cover;
  background-position: center;
}
.verticalLine {
  border-left: thin solid rgba(0,0,0,.2);
}
</style>
